export const enterpriseClients = [9458, 70910, 73002, 71999];
